export default "__VITE_ASSET__43b4ad9f__"